

export default {
  name: "handle",
  nickname: "手柄",
  desc:
    '拖拽手柄，适用于触屏的环境。参见 <a href="https://echarts.apache.org/examples/zh/editor.html?c=line-tooltip-touch&amp;edit=1&amp;reset=1" target="_blank">例子</a>。',
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc:
        '当 show 设为 <code class="codespan">true</code> 时开启，这时显示手柄，并且 axisPointer 会一直显示。',
      value: false,
      defaultValue: false,
    },
    icon: {
      name: "icon",
      nickname: "图表",
      desc: "手柄的图标。",
    },
    size: {
      name: "size",
      nickname: "尺寸",
      desc:
        '手柄的尺寸，可以设置单值，如 <code class="codespan">45</code>，也可以设置为数组：<code class="codespan">[width, height]</code>。',
      value: 45,
      defaultValue: 45,
      type: "pureValue",
    },
    margin: {
      name: "margin",
      nickname: "外边距",
      desc: "手柄与轴的距离。注意，这是手柄中心点和轴的距离。",
      value: 50,
      defaultValue: 50,
      type: "pureValue",
    },
    color: {
      name: "color",
      nickname: "颜色",
      desc: "手柄颜色。",
      value: "#333",
      defaultValue: "#333",
      type: "pureValue",
      eType: "color",
    },
    throttle: {
      name: "throttle",
      nickname: "throttle",
      desc:
        "手柄拖拽时触发视图更新周期，单位毫秒，调大这个数值可以改善性能，但是降低体验。",
      value: 40,
      defaultValue: 40,
      type: "pureValue",
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc:
        '图形阴影的模糊大小。该属性配合 <code class="codespan">shadowColor</code>,<code class="codespan">shadowOffsetX</code>, <code class="codespan">shadowOffsetY</code> 一起设置图形的阴影效果。',
      value: 3,
      defaultValue: 3,
      type: "pureValue",
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: '阴影颜色。支持的格式同<code class="codespan">color</code>。',
      value: "#aaa",
      defaultValue: "#aaa",
      type: "pureValue",
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "阴影水平方向上的偏移距离。",
      value: 2,
      defaultValue: 2,
      type: "pureValue",
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "阴影垂直方向上的偏移距离。",
      value: 0,
      defaultValue: 0,
    },
  },
}
